'use strict';

wbApp.directive('wbGroupSelect', ['$timeout', '$translate', 'groupSvc',
    function ($timeout, $translate, groupSvc) {
        function formatResult(model) {
            var colorUtils = new webooker_utils.ColorUtils();

            return "<div class='row' >" +
                       "<div class='col-xs-4'>" + model.name + "</div>" + 
                       "<div class='col-xs-7'>" + (model.description || "") + "</div>" +
                       "<div class='col-xs-1'><div style='background-color:" + colorUtils.intToRgb(model.color) + "; width: 100%; height: 18px; padding: 1px;'></div></div>" +
                   "</div>";
            }

        function formatSelection(model) {
            var colorUtils = new webooker_utils.ColorUtils();

            return "<div style='width:100%; height:18px; position: relative;'><div style='position:absolute; left:-4px; top: 0;background-color:" + colorUtils.intToRgb(model.color) + "; width: 18px; height: 18px;'></div><div style='position:relative;left: 0px; top:0; margin-left:22px;'>" + model.name + "</div></div>";
        }

        return {
            restrict: 'A',
            require: '?ngModel',
            priority: 1,
            scope: true,
            link: function (scope, elm, attrs, ctrl) {

                var models = groupSvc.getAllAsync(); 

                models.$promise.then(function () {
                    $timeout(function () {

                        $(elm).select2({
                            formatResult: formatResult,
                            formatSelection: formatSelection,
                            dropdownAutoWidth: true,
                            allowClear: false,
                            minimumResultsForSearch: -1,
                            id: function (model) { return model.groupID; },
                            data: models,
                            multiple: true
                        });

                        ctrl.$render();
                    });
                });


                ctrl.$parsers.unshift(function (viewValue) {
                    if (!viewValue) {
                        return [];
                    } else {
                        if (Array.isArray(viewValue)) {
                            return _.map(viewValue, function (n) { return parseInt(n); });
                        } else {
                            return _.map(viewValue.split(','), function (n) { return parseInt(n); });
                        }
                    }
                });

                ctrl.$formatters.unshift(function (value) {
                    if (!value) {
                        return "";
                    } else {
                        if (Array.isArray(value)) {
                            return _.map(value, function (n) { return n + ''; }).join();
                        } else {
                            return _.map(value.split(','), function (n) { return n + ''; }).join();
                        }
                    }
                });

                elm.bind("$destroy", function () {
                    elm.select2("destroy");
                });

                attrs.$observe('readonly', function (value) {
                    elm.select2('readonly', !!value);
                });
            }
        }
    }]);